export default __webpack_public_path__ + "static/media/google-play.d40b0eb4.svg";